import { Directive, Inject, OnInit, OnDestroy, OnChanges, Input, Output, EventEmitter, ElementRef } from '@angular/core';
import { CounterUpConfig, CounterUpConfigArgs } from './counter-up.config';
export class CounterUpDirective implements OnInit, OnChanges, OnDestroy {
/**
 * @param {?} value
 * @return {?}
 */
set number(value: string | number) {
    if (typeof(value) === 'number') {
      value = value.toString();
    }
    this._isComma = /[0-9]+,[0-9]+/.test(value);
    value = value.replace(/,/g, '');
    // this._decimalPlaces = (value.split('.')[1] || []).length;
    if (this._beginAt > parseInt(value, 10)) {
      this._beginAt = parseInt(value, 10);
    }
    this._isTime = /[0-9]+:[0-9]+:[0-9]+/.test(value);
    // Convert time to total seconds
    if (this._isTime) {
      const /** @type {?} */ times = value.split(':');
      let /** @type {?} */ m = 1, /** @type {?} */ s = 0;
      while (times.length > 0) {
        s += m * parseInt(times.pop(), 10);
        m *= 60;
      }
      this._number = s;
    } else {
      this._number = parseInt(value, 10);
    }
  }
/**
 * @param {?} value
 * @return {?}
 */
set offset(value: string) {
    if (/^\d+$/.test(value)) {
      this._offset = parseInt(value, 10);
    }
  }
/**
 * @param {?} value
 * @return {?}
 */
set formatter(value: string) {
    this._formatter = value;
  }

   complete: EventEmitter<any> = new EventEmitter<any>();
private _number: number;
private _isComma: boolean;
private _isTime: boolean;
private _seconds: number;
private _decimalPlaces: number;
private _delay: number;
private _time: number;
private _offset: number;
private _beginAt: number;
private _proceedNumber: number;
private _timestamp: any;
private _pause = false;
private _formatter = '';
/**
 * @param {?} el
 * @param {?} config
 */
constructor(
    protected el: ElementRef,
     config: CounterUpConfig
  ) {
    this._delay = config.delay;
    if (this._delay <= 0) {
      this._delay = 10;
    }
    this._time = config.time > 0 ? config.time : 100;
    this._beginAt = config.beginAt;
  }
/**
 * @return {?}
 */
ngOnInit() {
    let /** @type {?} */ number: number, /** @type {?} */ type: string;
    if (this._isTime) {
      type = 'time';
    } else if (this._isComma) {
      type = 'comma';
    } else {
      type = 'text';
    }
    if (this.el.nativeElement.innerHTML.length === 0) {
      number = this._beginAt;
    } else {
      number = this[type + '2number'](this.el.nativeElement.innerHTML);
    }
    this._proceedNumber = number;
    this.el.nativeElement.innerHTML = this.format(this['number2' + type](number));
    this.start();
  }
/**
 * @param {?} e
 * @return {?}
 */
ngOnChanges(e) {
    if (e.number && !e.number.firstChange) {
      this.start();
    }
  }
/**
 * @return {?}
 */
ngOnDestroy() {
    if (this._timestamp) {
      clearTimeout(this._timestamp);
    }
  }
/**
 * @return {?}
 */
private _increment() {
    if (this._timestamp) {
      clearTimeout(this._timestamp);
    }
    let /** @type {?} */ newValue = this._proceedNumber + this._offset, /** @type {?} */ text: string, /** @type {?} */ complete = false;
    if (newValue > this._number) {
      newValue = this._number;
      complete = true;
    }
    this._proceedNumber = newValue;
    if (this._isTime) {
      text = this.number2time(newValue);
    } else if (this._isComma) {
      text = this.number2comma(newValue);
    } else {
      text = this.number2text(newValue);
    }
    this.el.nativeElement.innerHTML = this.format(text);
    if (complete) {
      this.complete.emit({ target: this.el });
    } else if (!this._pause) {
      this._timestamp = setTimeout(() => this._increment(), this._delay);
    }
  }
/**
 * @return {?}
 */
start() {
    if (this._isTime) {
      this._offset = 1;
      this._delay = 1000;
    } else if (!this._offset) {
      this._offset = parseInt(((this._number - this._proceedNumber) / this._time).toString(), 10);
      if (this._offset < 1) {
        this._offset = 1;
      }
    }
    this._increment();
  }
/**
 * @return {?}
 */
pause() {
    this._pause = true;
  }
/**
 * @return {?}
 */
resume() {
    this._pause = false;
    this._increment();
  }
/**
 * @param {?} text
 * @return {?}
 */
private time2number(text: string): number {
    text = /[0-9]+:[0-9]+:[0-9]+/.test(text) ? text : '00:00:00';
    const /** @type {?} */ times = text.split(':');
    let /** @type {?} */ m = 1, /** @type {?} */ number = 0;
    while (times.length > 0) {
      number += m * parseInt(times.pop(), 10);
      m *= 60;
    }
    return number;
  }
/**
 * @param {?} number
 * @return {?}
 */
private number2time(number: number): string {
    const /** @type {?} */ hours = parseInt((number / 3600).toString(), 10) % 24, /** @type {?} */
          minutes = parseInt((number / 60).toString(), 10) % 60, /** @type {?} */
          seconds = number % 60;
    return (hours < 10 ? '0' + hours : hours) + ':' +
          (minutes < 10 ? '0' + minutes : minutes) + ':' +
          (seconds < 10 ? '0' + seconds : seconds);

  }
/**
 * @param {?} text
 * @return {?}
 */
private comma2number(text: string): number {
    return parseInt(text.replace(/,/g, ''), 10);
  }
/**
 * @param {?} number
 * @return {?}
 */
private number2comma(number: number): string {
    let /** @type {?} */ text = number.toString();
    while (/(\d+)(\d{3})/.test(text)) {
      text = text.replace(/(\d+)(\d{3})/, '$1' + ',' + '$2');
    }
    return text;
  }
/**
 * @param {?} text
 * @return {?}
 */
private text2number(text: string): number {
    return parseInt(text, 10);
  }
/**
 * @param {?} number
 * @return {?}
 */
private number2text(number: number): string {
    return number.toString();
  }
/**
 * @param {?} text
 * @return {?}
 */
private format(text: string): string {
    if (this._formatter.length === 0) {
      return text;
    }
    return this._formatter.replace(/%s/g, text);
  }

static decorators: DecoratorInvocation[] = [
{ type: Directive, args: [{
  selector: '[counter-up]'
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: ElementRef, },
{type: CounterUpConfig, decorators: [{ type: Inject, args: [CounterUpConfig, ] }, ]},
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'number': [{ type: Input },],
'offset': [{ type: Input },],
'formatter': [{ type: Input },],
'complete': [{ type: Output },],
};
}

function CounterUpDirective_tsickle_Closure_declarations() {
/** @type {?} */
CounterUpDirective.decorators;
/**
 * @nocollapse
 * @type {?}
 */
CounterUpDirective.ctorParameters;
/** @type {?} */
CounterUpDirective.propDecorators;
/** @type {?} */
CounterUpDirective.prototype.complete;
/** @type {?} */
CounterUpDirective.prototype._number;
/** @type {?} */
CounterUpDirective.prototype._isComma;
/** @type {?} */
CounterUpDirective.prototype._isTime;
/** @type {?} */
CounterUpDirective.prototype._seconds;
/** @type {?} */
CounterUpDirective.prototype._decimalPlaces;
/** @type {?} */
CounterUpDirective.prototype._delay;
/** @type {?} */
CounterUpDirective.prototype._time;
/** @type {?} */
CounterUpDirective.prototype._offset;
/** @type {?} */
CounterUpDirective.prototype._beginAt;
/** @type {?} */
CounterUpDirective.prototype._proceedNumber;
/** @type {?} */
CounterUpDirective.prototype._timestamp;
/** @type {?} */
CounterUpDirective.prototype._pause;
/** @type {?} */
CounterUpDirective.prototype._formatter;
/** @type {?} */
CounterUpDirective.prototype.el;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
